import { InvoiceThird } from './invoice-third.model';

export class InvoicePlace {
  third: InvoiceThird | null;
  costCenter: string;

  constructor(values= {}) {
    Object.assign(this, values);

    if (this.third) {
      this.third = new InvoiceThird(this.third);
    }
  }
}
